import React from 'react';

import classNames from 'classnames';
import ChevronLeftIcon from 'icons/chevron-left.svg';
import ChevronRightIcon from 'icons/chevron-right.svg';
import { useTranslation } from 'react-i18next';

export default function Stepper({
  currentStep,
  onStepDown,
  onStepUp,
  totalSteps,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const steppingDisabled = totalSteps === currentStep && totalSteps === 1;

  return (
    <div
      className={classNames(
        'stepper',
        steppingDisabled && 'tw-pointer-events-none tw-opacity-30',
      )}
    >
      <div
        className='stepper__nav stepper__left tw-bg-grey-050 hover:tw-bg-blue-050 [&_svg_polygon]:tw-fill-grey-700 [&_svg_polygon]:hover:tw-fill-grey-900'
        onClick={onStepDown}
      >
        <ChevronLeftIcon />
      </div>
      <div className='stepper__info tw-bg-grey-025 tw-font-medium tw-text-grey-600'>
        {i18nTShared('currentStepOfTotalSteps', { currentStep, totalSteps })}
      </div>
      <div
        className='stepper__nav stepper__right tw-bg-grey-050 hover:tw-bg-blue-050 [&_svg_polygon]:tw-fill-grey-700 [&_svg_polygon]:hover:tw-fill-grey-900'
        onClick={onStepUp}
      >
        <ChevronRightIcon />
      </div>
    </div>
  );
}
